import React, { useEffect, useState } from "react";
import axios from "axios";
import { useI18n } from "@/i18n/I18nContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function Prose({ section, fallbackTitle }) {
  const { content, lang, t } = useI18n();
  const [fallback, setFallback] = useState(null);
  const block = content?.[section];

  // If current language doesn't have this section, fetch English as fallback
  useEffect(() => {
    if (block || lang === "en") {
      setFallback(null);
      return;
    }
    let cancel = false;
    axios.get(`${API}/content/en/${section}`)
      .then((r) => { if (!cancel) setFallback(r.data); })
      .catch(() => { if (!cancel) setFallback(null); });
    return () => { cancel = true; };
  }, [section, lang, block]);

  const data = block || fallback;

  if (!data || !data.body) {
    return (
      <div className="prose prose-stone max-w-none" data-testid={`prose-loading-${section}`}>
        <p className="text-stone-500 italic">{t("no_content_yet")}</p>
      </div>
    );
  }

  const paragraphs = data.body.split(/\n\n+/g);

  return (
    <div data-testid={`prose-${section}`}>
      {!block && fallback && (
        <p className="text-xs uppercase tracking-[0.15em] text-stone-400 mb-2 italic">
          (English – translation in progress)
        </p>
      )}
      {data.subtitle && (
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--brand-primary)]/80 mb-3">
          {data.subtitle}
        </p>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 mb-6">
        {data.title || fallbackTitle}
      </h2>
      <div className="space-y-5 text-stone-700 leading-relaxed text-base sm:text-lg">
        {paragraphs.map((p, i) => {
          if (p.trim().startsWith("- ")) {
            const items = p.split(/\n/).filter((l) => l.trim().startsWith("- "));
            return (
              <ul key={i} className="ps-5 list-disc space-y-2">
                {items.map((li, j) => (
                  <li key={j}>{li.replace(/^-\s*/, "")}</li>
                ))}
              </ul>
            );
          }
          return <p key={i}>{p}</p>;
        })}
      </div>
    </div>
  );
}
